<template>
  <div class="landing">
    <!-- Hero 区域 -->
    <div class="hero">
      <div class="hero-inner">
        <div class="hero-text">
          <div class="alipay-logo">支</div>
          <h1 class="hero-title">支付宝支付</h1>
          <p class="hero-sub">请根据以下信息完成转账，或扫码系统将自动核验到账</p>
        </div>
      </div>
    </div>

    <!-- 内容区域 -->
    <div class="content">
      <!-- 加载中 -->
      <div v-if="loading">
        <div class="card">
          <div class="card-body center loading-wrap">
            <div class="loader"></div>
            <p class="loading-text">正在加载支付信息...</p>
          </div>
        </div>
      </div>

      <!-- 错误提示 -->
      <div v-else-if="error">
        <div class="card">
          <div class="card-body center">
            <span class="badge">提示</span>
            <p class="error-text">{{ error }}</p>
          </div>
        </div>
      </div>

      <!-- 已支付提示 -->
      <div v-else-if="paid">
        <div class="card">
          <div class="card-body center">
            <div class="success-icon">✅</div>
            <h3 class="result-title">订单已支付</h3>
            <p class="result-sub">请勿重复转账</p>
          </div>
        </div>
      </div>

      <!-- 已超时提示 -->
      <div v-else-if="expired">
        <div class="card">
          <div class="card-body center">
            <div class="timeout-icon">⏰</div>
            <h3 class="result-title">订单已超时</h3>
            <p class="result-sub">请返回并重新发起支付</p>
          </div>
        </div>
      </div>

      <!-- 支付信息 -->
      <div v-else class="row">
        <div class="col-left">
          <div class="card info-card">
            <div class="card-header info-header">
              <span>订单支付信息</span>
              <span class="countdown" v-if="countdownSeconds > 0">
                剩余支付时间：
                <span class="countdown-time">{{ formattedCountdown }}</span>
              </span>
              <span class="countdown ended" v-else>支付倒计时已结束</span>
            </div>
            <div class="card-body">
              <div class="form">
                <div
                  class="form-item"
                  v-for="(value, key) in displayInfoMap"
                  :key="key"
                  :class="{ 'amount-item': key === 'paymentAmount' }"
                >
                  <label class="form-label">{{ value.label }}</label>
                  <div class="input-block field-row">
                    <span
                      class="field-value"
                      :class="{ mono: key === 'payerAccount', amount: key === 'paymentAmount' }"
                    >
                      {{ data[value.key] }}
                    </span>
                    <button
                      class="copy-btn"
                      @click="copyText(data[value.key])"
                    >
                      复制
                    </button>
                  </div>
                </div>
              </div>
              <div class="tips">
                <span class="tip-icon">📌</span>
                请仔细核对以上信息，转账请备注订单号以便快速核验。
              </div>
              <!-- 二维码展示区域 -->
              <div v-if="showQRCode" class="qrcode-section">
                <div class="qrcode-title">扫码支付</div>
                <div class="qrcode-wrapper">
                  <div id="qrcode" ref="qrcode" title=""></div>
                </div>
                <p class="qrcode-tip">使用支付宝扫描上方二维码完成支付</p>
              </div>
            </div>
          </div>
        </div>

        <div class="col-right">
          <div class="card side-card">
            <div class="card-header">温馨提示</div>
            <div class="card-body">
              <ul class="timeline">
                <li class="timeline-item">
                  <span class="timeline-icon">⏰</span>
                  <div class="timeline-content">
                    <h3 class="timeline-title">到账时间</h3>
                    <p>支付宝转账一般实时到账，跨行转账可能延迟1-2小时。</p>
                  </div>
                </li>
                <li class="timeline-item">
                  <span class="timeline-icon">💰</span>
                  <div class="timeline-content">
                    <h3 class="timeline-title">金额一致</h3>
                    <p>请按页面金额转账，若不一致可能无法自动匹配。</p>
                  </div>
                </li>
                <li class="timeline-item">
                  <span class="timeline-icon">🔒</span>
                  <div class="timeline-content">
                    <h3 class="timeline-title">防骗提醒</h3>
                    <p>谨防冒充支付宝客服的电话或短信，不要透露任何验证码。</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import apiConfig from "@/config/api";
import QRCode from "qrcodejs2";

export default {
  name: "AlipayTransfer",
  data() {
    return {
      data: {},
      loading: true,
      error: null,
      countdownSeconds: 0,
      countdownTimerId: null,
      expired: false,
      paid: false,
      qrCode: null,
      qrcodeInstance: null,
      showQRCode: false,
      infoMap: {
        merchantOrderNo: { label: "订单号", key: "merchantOrderNo" },
        paymentAmount: { label: "支付金额", key: "paymentAmount" },
        payerName: { label: "收款人", key: "payerName" },
        payerBankName: { label: "收款方式", key: "payerBankName" },
        payerAccount: { label: "收款账号", key: "payerAccount" }
      }
    };
  },
  methods: {
    copyText(text) {
      const textarea = document.createElement("textarea");
      textarea.value = text;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
      if (window.layui?.layer) {
        window.layui.layer.msg("已复制到剪贴板", { icon: 1, time: 1500 });
      } else {
        alert("✅ 已复制到剪贴板");
      }
    },
    startCountdown(totalSeconds) {
      this.clearCountdown();
      this.countdownSeconds = totalSeconds;
      this.countdownTimerId = setInterval(() => {
        if (this.countdownSeconds > 0) {
          this.countdownSeconds--;
          if (this.countdownSeconds === 0) {
            this.onCountdownEnd();
          }
        }
      }, 1000);
    },
    clearCountdown() {
      if (this.countdownTimerId) {
        clearInterval(this.countdownTimerId);
        this.countdownTimerId = null;
      }
    },
    onCountdownEnd() {
      // 不做任何动作，等后端推送控制
    },
    handleWebSocketMessage(data) {
      const merchantOrderNo = this.data.merchantOrderNo;
      console.log("📩 收到推送消息：", data);

      if (data.type === "order_timeout" && data.merchantOrderNo === merchantOrderNo) {
        console.warn("⏱ 收到订单超时推送");
        this.clearCountdown();
        this.expired = true;
      }

      if (data.type === "order_paid" && data.merchantOrderNo === merchantOrderNo) {
        console.log("💰 收到订单到账推送");
        this.clearCountdown();
        this.paid = true;
      }
    },
    initQRCode(qrCodeBase64) {
      if (!qrCodeBase64) {
        console.warn("qrCodeBase64 为空，无法生成二维码");
        return;
      }
      
      try {
        // 解码 base64 字符串获取 URL
        const qrCodeUrl = atob(qrCodeBase64);
        console.log("解码后的二维码 URL:", qrCodeUrl);
        this.qrCode = qrCodeUrl;
        this.showQRCode = true; // 显示二维码区域
        
        // 等待 DOM 更新后生成二维码
        this.$nextTick(() => {
          // 使用 setTimeout 确保 DOM 完全渲染
          setTimeout(() => {
            if (!this.$refs.qrcode) {
              console.error("二维码容器元素不存在，refs:", this.$refs);
              return;
            }
            
            // 清除之前的二维码实例
            if (this.qrcodeInstance) {
              this.$refs.qrcode.innerHTML = "";
              this.qrcodeInstance = null;
            }
            
            // 生成新的二维码
            try {
              console.log("开始生成二维码，容器元素:", this.$refs.qrcode);
              this.qrcodeInstance = new QRCode(this.$refs.qrcode, {
                text: qrCodeUrl,
                width: 200,
                height: 200,
                colorDark: "#000000",
                colorLight: "#ffffff",
                correctLevel: QRCode.CorrectLevel.H
              });
              console.log("二维码生成成功，URL:", qrCodeUrl);
              
              // 隐藏二维码的实际内容，防止鼠标悬停时显示 URL
              this.$nextTick(() => {
                const qrcodeElement = this.$refs.qrcode;
                if (qrcodeElement) {
                  // 移除容器本身的 title 属性
                  qrcodeElement.removeAttribute('title');
                  qrcodeElement.setAttribute('title', '');
                  
                  // 移除所有链接元素
                  const links = qrcodeElement.querySelectorAll('a');
                  links.forEach(link => {
                    link.removeAttribute('title');
                    const parent = link.parentNode;
                    while (link.firstChild) {
                      parent.insertBefore(link.firstChild, link);
                    }
                    parent.removeChild(link);
                  });
                  
                  // 移除所有元素的 title 属性
                  const allElements = qrcodeElement.querySelectorAll('*');
                  allElements.forEach(el => {
                    el.removeAttribute('title');
                    if (el.tagName === 'CANVAS' || el.tagName === 'IMG') {
                      el.style.pointerEvents = 'none';
                    }
                    if (el.tagName === 'IMG') {
                      el.removeAttribute('alt');
                    }
                  });
                  
                  // 移除 canvas 和 img 的 title 属性
                  const canvas = qrcodeElement.querySelector('canvas');
                  const img = qrcodeElement.querySelector('img');
                  if (canvas) {
                    canvas.removeAttribute('title');
                    canvas.setAttribute('title', '');
                    canvas.style.pointerEvents = 'none';
                  }
                  if (img) {
                    img.removeAttribute('title');
                    img.setAttribute('title', '');
                    img.removeAttribute('alt');
                    img.style.pointerEvents = 'none';
                  }
                  
                  // 为整个容器添加样式，防止显示 URL
                  qrcodeElement.style.pointerEvents = 'none';
                }
              });
            } catch (qrError) {
              console.error("QRCode 初始化失败：", qrError);
            }
          }, 100);
        });
      } catch (error) {
        console.error("二维码生成失败：", error);
      }
    }
  },
  created() {
    const merchantOrderNo = this.$route.params.merchantOrderNo;
    // 支持从查询参数中获取 qrCode（用于测试）
    const qrCodeFromQuery = this.$route.query.qrCode;
    if (qrCodeFromQuery) {
      console.log("从查询参数获取到 qrCode，开始初始化二维码");
      this.initQRCode(qrCodeFromQuery);
    }

    this.$ws.connect();

    this.$ws._handleMessage = (rawData) => {
      let data = rawData;
      if (typeof data === "string") {
        try {
          data = JSON.parse(data);
        } catch (e) {
          console.error("❌ WebSocket 消息解析失败", rawData);
          return;
        }
      }
      this.handleWebSocketMessage(data);
    };

    // 获取订单详情
    axios.get(apiConfig.getCommonInterfaceUrl(), {
      params: { merchantOrderNo }
    })
      .then((res) => {
        if (res.data.code === 200) {
          this.data = res.data.data;
          const expireTime = new Date(this.data.expire_time).getTime();
          const nowTime = Date.now();
          const diffSeconds = Math.floor((expireTime - nowTime) / 1000);
          if (diffSeconds > 0) {
            this.startCountdown(diffSeconds);
          } else {
            this.expired = true;
          }

          // 初始化二维码（如果查询参数中没有）
          if (!this.$route.query.qrCode) {
            console.log("订单数据：", res.data.data);
            if (res.data.data.qrCode) {
              console.log("检测到 qrCode 参数，开始初始化二维码");
              this.initQRCode(res.data.data.qrCode);
            } else {
              console.warn("订单数据中未找到 qrCode 参数");
            }
          }

          // 绑定订单
          this.$ws.send(
            JSON.stringify({
              type: "bind_order",
              merchantOrderNo
            })
          );
        } else {
          this.error = res.data.msg || "订单获取失败";
        }
      })
      .catch(() => {
        this.error = "请求失败，无法获取订单信息";
      })
      .finally(() => {
        this.loading = false;
      });
  },
  computed: {
    formattedCountdown() {
      const mins = Math.floor(this.countdownSeconds / 60);
      const secs = this.countdownSeconds % 60;
      return `${String(mins).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
    },
    displayInfoMap() {
      if (this.showQRCode) {
        const map = { ...this.infoMap };
        delete map.payerAccount;
        return map;
      }
      return this.infoMap;
    }
  },
  beforeDestroy() {
    this.clearCountdown();
    // 清理二维码实例
    if (this.qrcodeInstance && this.$refs.qrcode) {
      this.$refs.qrcode.innerHTML = "";
      this.qrcodeInstance = null;
    }
  }
};
</script>

<style scoped>
/* 支付宝风格布局 */
.landing {
  background-color: #f5f5f7;
  min-height: 100vh;
  font-family: -apple-system, BlinkMacSystemFont, 'SF Pro Display', 'SF Pro Text', 'Helvetica Neue', Arial, sans-serif;
}

.hero {
  background: linear-gradient(135deg, #1677ff 0%, #0d5fd3 100%);
  color: #fff;
  padding: 60px 0 40px;
  text-align: center;
  border-bottom: none;
}

.hero-inner {
  max-width: 980px;
  margin: 0 auto;
  padding: 0 22px;
}

.hero-text {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.alipay-logo {
  width: 80px;
  height: 80px;
  background: #1677ff;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
  font-size: 48px;
  font-weight: 700;
  color: #fff;
}

.hero-title {
  font-size: 48px;
  font-weight: 600;
  margin: 0 0 12px;
  letter-spacing: -0.015em;
  color: #fff;
}

.hero-sub {
  font-size: 21px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.9);
  margin: 0;
}

.content {
  margin: 40px auto 80px;
  max-width: 980px;
  padding: 0 22px;
}

/* 支付宝风格卡片 */
.card {
  background: #ffffff;
  border-radius: 18px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04), 0 1px 2px rgba(0, 0, 0, 0.08);
  border: 1px solid #f5f5f7;
  overflow: hidden;
  margin-bottom: 24px;
}

.card-header {
  background: transparent;
  border: none;
  padding: 28px 28px 0;
  font-size: 17px;
  font-weight: 600;
  color: #1d1d1f;
}

.info-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.countdown {
  font-size: 14px;
  color: #1677ff;
  font-weight: 400;
}

.countdown-time {
  color: #ff4d4f;
  font-weight: 600;
}

.countdown.ended {
  color: #d70015;
}

.card-body {
  padding: 0 28px 28px;
}

/* 分栏布局 */
.row {
  display: flex;
  gap: 30px;
}

.col-left {
  flex: 0 0 58.333333%;
  max-width: 58.333333%;
}

.col-right {
  flex: 0 0 41.666667%;
  max-width: 41.666667%;
}

/* 表单项样式 */
.form {
  margin: 0;
}

.form-item {
  margin-bottom: 24px;
  padding-bottom: 24px;
  border-bottom: 1px solid #f5f5f7;
  display: flex;
  align-items: center;
  gap: 0;
}

.form-item:first-child {
  margin-top: 0;
  padding-top: 8px;
}

.form-item:last-child {
  margin-bottom: 0;
  padding-bottom: 0;
  border-bottom: none;
}

.form-label {
  font-size: 15px;
  font-weight: 500;
  color: #86868b;
  width: 90px;
  min-width: 90px;
  text-align: left;
  padding: 0;
  line-height: 22px;
  margin: 0;
  margin-right: 8px;
  background: none;
  border: none;
  display: flex;
  align-items: center;
}

.input-block {
  margin-left: 0;
  width: auto;
  flex: 1;
}

.field-row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: nowrap;
  margin: 0;
  flex: 1;
  min-width: 0;
}

.field-value {
  font-size: 17px;
  color: #1d1d1f;
  flex: 1;
  min-width: 100px;
  word-break: break-all;
  line-height: 22px;
  margin: 0;
  padding: 0;
  height: 22px;
  display: inline-block;
}

.field-value.mono {
  font-family: 'SF Mono', Monaco, 'Cascadia Code', 'Roboto Mono', Consolas, 'Courier New', monospace;
}

.field-value.amount {
  font-size: 17px;
  font-weight: 400;
  color: #1d1d1f;
}

/* 支付宝风格按钮 */
.copy-btn {
  min-width: 80px;
  background: #1677ff;
  border: none;
  border-radius: 980px;
  color: #ffffff;
  font-size: 14px;
  font-weight: 400;
  padding: 6px 16px;
  transition: all 0.2s ease;
  line-height: 22px !important;
  height: 34px;
  white-space: nowrap;
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
}

.copy-btn:hover {
  background: #0958d9;
  transform: scale(1.05);
}

.copy-btn:active {
  transform: scale(0.98);
}

.tips {
  margin-top: 24px;
  padding: 16px;
  border-radius: 12px;
  background: #f5f5f7;
  color: #6e6e73;
  font-size: 13px;
  display: flex;
  align-items: center;
  gap: 8px;
  line-height: 1.5;
}

.tip-icon {
  font-size: 16px;
  color: #1677ff;
  flex-shrink: 0;
}

/* 二维码展示区域 */
.qrcode-section {
  margin-top: 32px;
  padding-top: 32px;
  border-top: 1px solid #f5f5f7;
  text-align: center;
}

.qrcode-title {
  font-size: 17px;
  font-weight: 600;
  color: #1d1d1f;
  margin-bottom: 20px;
}

.qrcode-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #f5f5f7;
  margin-bottom: 16px;
}

#qrcode {
  display: inline-block;
  pointer-events: none;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}

#qrcode canvas,
#qrcode img {
  pointer-events: none;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}

#qrcode a {
  pointer-events: none;
  text-decoration: none;
}

.qrcode-tip {
  font-size: 14px;
  color: #6e6e73;
  margin: 0;
  line-height: 1.5;
}

/* 加载与错误 */
.center {
  text-align: center;
}

.loading-wrap {
  padding: 60px 0;
}

.loading-text {
  color: #86868b;
  font-size: 17px;
  margin-top: 16px;
}

.error-text {
  color: #d70015;
  margin-top: 16px;
  font-size: 17px;
}

.success-icon,
.timeout-icon {
  font-size: 48px;
  margin-bottom: 16px;
}

.result-title {
  font-size: 20px;
  font-weight: 600;
  margin: 0 0 8px;
}

.result-sub {
  color: #666;
  margin: 0;
}

.badge {
  display: inline-block;
  padding: 4px 12px;
  background: #1677ff;
  color: #fff;
  border-radius: 4px;
  font-size: 12px;
  margin-bottom: 8px;
}

.loader {
  width: 40px;
  height: 40px;
  border: 3px solid #f5f5f7;
  border-top-color: #1677ff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 8px;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* 右侧提示卡片样式 */
.side-card .timeline {
  padding: 0;
  list-style: none;
  margin: 0;
}

.side-card .timeline-item {
  padding-bottom: 20px;
  margin-bottom: 20px;
  border-bottom: 1px solid #f5f5f7;
  display: flex;
  align-items: flex-start;
}

.side-card .timeline-item:last-child {
  margin-bottom: 0;
  padding-bottom: 0;
  border-bottom: none;
}

.timeline-icon {
  font-size: 20px;
  flex-shrink: 0;
  margin-right: 12px;
  margin-top: 2px;
}

.timeline-content {
  flex: 1;
}

.timeline-title {
  font-size: 15px;
  font-weight: 600;
  color: #1d1d1f;
  margin: 0 0 6px;
}

.timeline-content p {
  margin: 0;
  font-size: 14px;
  color: #6e6e73;
  line-height: 1.5;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .landing {
    padding-bottom: env(safe-area-inset-bottom);
  }

  .info-header {
    flex-direction: row;
    align-items: center;
    gap: 12px;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .countdown {
    font-size: 12px;
    margin-left: auto;
  }

  .hero {
    padding: 40px 0 24px;
  }

  .hero-title {
    font-size: 28px;
  }

  .hero-sub {
    font-size: 15px;
  }

  .content {
    margin: 24px auto 0;
    padding: 0 20px;
    padding-bottom: max(40px, env(safe-area-inset-bottom) + 20px);
  }

  .row {
    flex-direction: column;
    gap: 0;
  }

  .col-left,
  .col-right {
    flex: 1;
    max-width: 100%;
  }

  .card-header {
    padding: 16px 16px 0;
    font-size: 15px;
  }

  .card-body {
    padding: 0 16px 16px;
  }

  .field-row {
    gap: 8px;
    flex-wrap: nowrap;
  }

  .field-value {
    font-size: 16px;
    min-width: 0;
    flex: 1;
  }

  .field-value.mono {
    font-size: 16px;
  }

  .field-value.amount {
    font-size: 16px;
  }

  .copy-btn {
    min-width: 80px;
    flex-shrink: 0;
  }

  .tips {
    font-size: 13px;
    margin-top: 16px;
  }

  .qrcode-section {
    margin-top: 24px;
    padding-top: 24px;
  }

  .qrcode-title {
    font-size: 16px;
    margin-bottom: 16px;
  }

  .qrcode-wrapper {
    padding: 16px;
  }

  .qrcode-tip {
    font-size: 13px;
  }

  .form-item {
    margin-bottom: 12px;
    padding-bottom: 12px;
  }

  .form-item:first-child {
    padding-top: 4px;
  }

  .card {
    margin-bottom: 16px;
  }

  .card:last-child {
    margin-bottom: 0;
    padding-bottom: 0;
  }

  .info-card {
    margin-bottom: 12px;
  }

  .side-card {
    margin-top: 16px;
  }

  .side-card .timeline-item {
    padding-bottom: 12px;
    margin-bottom: 12px;
  }

  .side-card .timeline-title {
    font-size: 14px;
    margin: 0 0 4px;
  }

  .side-card .timeline-content p {
    font-size: 13px;
  }
}

/* 极窄屏处理 */
@media (max-width: 360px) {
  .hero-title {
    font-size: 28px;
  }

  .hero-sub {
    font-size: 15px;
  }
}
</style>
